//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
let d=[[],[[["memberFrecs"],"SetMemberFeatures",{},1,0],[["expData","defineValues"],"SetExpressionsData",{},2,0],[["extRefs","refPrompts"],"SetExternalReferences",{},2,0],[["name"],"SetName",{},1,0],[["helpUrl"],"SetHelpUrl",{},1,0],[["deleteExistingDef"],"SetDeleteExistingDefinition",{},1,0]],[]];
SPLM.Features.DeformDefinitionBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.DeformDefinitionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.DeformDefinitionBuilder.JaDeformDefinitionExpData = class{
    constructor(type,exp,expName,lowEnd,highEnd,scaleType){
        this.type=type;this.exp=exp;this.expName=expName;this.lowEnd=lowEnd;this.highEnd=highEnd;this.scaleType=scaleType;}
    get Type(){return this.type}
    set Type(val){this.type = val}
    get Exp(){return this.exp}
    set Exp(val){this.exp = val}
    get Expname(){return this.expName}
    set Expname(val){this.expName = val}
    get Lowend(){return this.lowEnd}
    set Lowend(val){this.lowEnd = val}
    get Highend(){return this.highEnd}
    set Highend(val){this.highEnd = val}
    get Scaletype(){return this.scaleType}
    set Scaletype(val){this.scaleType = val}
};

SPLM.Features.DeformDefinitionBuilder.ExpressionType = Object.freeze({
    "Exp" : "Exp", "Range" : "Range", "Option" : "Option"});

SPLM.Features.DeformDefinitionBuilder.RangeType = Object.freeze({
    "Int" : "Int", "Real" : "Real"});

export default SPLM;